import { defineComponent as _defineComponent } from 'vue'
import { Tag, Typo } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';
  import getHotelFeatures from '../lib/getHotelFeatures';
  import { type IDistances } from '../types/IDistances';

  interface HotelFeaturesProps {
    attributes: number[];
    distances: IDistances;
    types: number[];
    placement?: number | null;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelFeatures',
  props: {
    attributes: null,
    distances: null,
    types: null,
    placement: { default: null }
  },
  setup(__props: any) {

const props = __props as { attributes: number[], distances: IDistances, types: number[], placement: number | null }

  

  const features = computed(() =>
    getHotelFeatures({
      attributes: props.attributes,
      distances: props.distances,
      types: props.types,
      placement: props.placement,
    }),
  );

return { __sfc: true,props, features, Tag, Typo }
}

})